import { Component, ElementRef, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { EventRecorderService } from '../services/WebScrapingRecorder.service';

@Component({
    selector: 'web-scraping',
    templateUrl: './web-scraping.component.html',
    styleUrl: './web-scraping.component.scss',
    standalone: false
})
export class WebScrapingComponent {

  constructor(public domSanitizer:DomSanitizer){}
  current_url: SafeResourceUrl = null;
  @ViewChild('iframe') iframe:ElementRef;


  navigate(url){
    this.iframe.nativeElement.addEventListener('mousedown', this.handleMouseDown, true);
    this.current_url=this.domSanitizer.bypassSecurityTrustResourceUrl("http://localhost:3000/proxy?url="+url)
  }

  handleMouseDown(e) {
    e.preventDefault();
    e.stopPropagation();
    
    document.addEventListener('mousemove', this.handleMouseMove, true);
    document.addEventListener('mouseup', this.removeMouseListeners, true);
    
    console.log(`listeners added`);
  }

  handleMouseMove(e) {
    e.preventDefault();
    console.log(`${e.clientX},${e.clientY}`);
  }
  
  removeMouseListeners(e) {
    document.removeEventListener('mousemove', this.handleMouseMove, true);
    document.removeEventListener('mouseup', this.removeMouseListeners, true);
    console.log('listeners removed');
  }

}
